(() => {
  const hydrateMobileMenuCards = () => {
    const template = document.querySelector('[data-mobile-menu-cards-template]');
    const targets = document.querySelectorAll('[data-mobile-menu-cards-target], [data-mega-menu-cards-target]');

    if (!(template instanceof HTMLTemplateElement) || targets.length === 0) return;

    const cardCount = template.content.children.length;

    targets.forEach((target) => {
      if (target.children.length !== cardCount) {
        target.replaceChildren(template.content.cloneNode(true));
      }
    });

    const mobileTarget = document.querySelector('[data-mobile-menu-cards-target]');
    const mobileContainer = document.querySelector('[data-mobile-menu-cards-container]');

    if (mobileTarget instanceof HTMLElement && mobileContainer instanceof HTMLElement) {
      mobileContainer.hidden = mobileTarget.children.length === 0;
    }
  };

  let hydrationQueued = false;
  const scheduleHydration = () => {
    if (hydrationQueued) return;

    hydrationQueued = true;
    queueMicrotask(() => {
      hydrationQueued = false;
      hydrateMobileMenuCards();
    });
  };

  new MutationObserver(scheduleHydration).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scheduleHydration, { once: true });
  document.addEventListener('shopify:section:load', scheduleHydration);
  scheduleHydration();
})();
